import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { memo } from 'react';
import { useT } from '../../translation/src';

interface HeaderProps {
  // Renders a close icon on the right of the title.
  onClose?: () => void;
}

const Header_: React.FC2<HeaderProps> = ({ children, className, onClose, ...props }) => {
  const close = useT('close', { swc: true });
  return (
    <Dialog.Title {...props} className={classNames(className, 'flex items-center text-lg mb-6', onClose && 'justify-between gap-2')}>
      {children}
      {onClose && (
        <button type="button" onClick={onClose} title={close} aria-label={close} className="shrink-0 cursor-pointer text-gray-500 transition-colors hover:text-black dark:text-gray-400 dark:hover:text-white">
          <XMarkIcon className="w-5 h-5" />
        </button>
      )}
    </Dialog.Title>
  );
};

export const Header = memo(Header_);
